export const ALL_API_KEY_SCOPES = [
  'answers:read',
  'answers:write',
  'customers:read',
  'customers:write',
  'team-members:read',
  'team-members:write',
  'responses:read',
  'responses:write',
  'surveys:read',
  'questions:read',
]



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/ApiKey/constants.js